
export async function aiUsageFetch(url, options = {}) {
  const headers = { ...options.headers };
  Object.assign(headers, await aiAccountHeaders());
  return fetch(url, { ...options, headers });
}

export async function aiAccountHeaders() {
  const { getAuth } = await import("firebase/auth");
  const user = getAuth().currentUser;
  return user ? { Authorization: `Bearer ${await user.getIdToken()}` } : {};
}
